'use client';

import { createContext, type ReactNode, useContext } from 'react';

const ExitIntentExperimentContext = createContext<boolean>(false);

export function ExitIntentExperimentProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  return (
    <ExitIntentExperimentContext.Provider value={enabled}>
      {children}
    </ExitIntentExperimentContext.Provider>
  );
}

export function useIsExitIntentEnabled(): boolean {
  return useContext(ExitIntentExperimentContext);
}
